module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("cyJzQ"))).then(() => parcelRequire('37nVf'));